// src/content/antes.ts
//
// Ante targets retuned 2026-04-28 after manual playtest. The spec's locked
// numbers (300/450/600, 800/1200/1800, 2500/4000/6000) assumed Balatro-scale
// chips/mults; with v1's standard deck (chips=10, mult=1, even-money payout=1)
// even a perfect 3-hit even-money round caps at 30/spin = 90/round, well below
// 300. Plus the chain bonus (×1/×2/×4/×8 per scoring fiche) was added in the
// same playtest pass, which roughly doubles realistic round totals.
// Per MONEY-02: round-clear rewards = 4 / 6 / 8 (unchanged).
//
// Retuned again 2026-05-01 (HBM-FIX-02): prior curve had a 2.7× wall from
// ante 1 boss (150) → ante 2 small (400). New curve targets ~1.5–1.7× within
// each ante and a gentle ~1.2–1.4× jump between antes so the game stays
// playable through ante 2 without a difficulty cliff.

export interface AnteConfig {
  ante: 1 | 2 | 3;
  targets: { small: number; big: number; boss: number };
  rewards: { small: number; big: number; boss: number };
}

export const ANTES: readonly AnteConfig[] = Object.freeze([
  { ante: 1, targets: { small: 30, big: 60, boss: 100 }, rewards: { small: 4, big: 6, boss: 8 } },
  { ante: 2, targets: { small: 120, big: 210, boss: 350 }, rewards: { small: 4, big: 6, boss: 8 } },
  {
    ante: 3,
    targets: { small: 490, big: 840, boss: 1390 },
    rewards: { small: 4, big: 6, boss: 8 },
  },
]);
